<template>
  <div>

    <div class="loader" v-bind:class=" { active: !isReady } "></div>
    
    <div id="app" v-bind:class=" { active: isReady } ">

      <navbar />

      <transition
          name="fade"
          mode="out-in"
        >
        <router-view id="my-router-view" v-bind:class=" { active: isActive } "></router-view>
      </transition>

      <footbar />

      <transition
          name="fade"
          mode="out-in"
        >
      <popupoverlay v-if="popup.showMe" />
      <takeawaypopup v-if="takeaway_popup.showMe" />
    </transition>
      <div id="rotate-warning">
        <div id="rotate-container">
          <div id="rotate-sprite"></div>
          <h3>Please rotate your device</h3>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import footbar from './components/Footbar.vue'
import popupoverlay from './components/PopupOverlay.vue'
import takeawaypopup from './components/TakeawayPopup.vue'
import navbar from './components/Navbar.vue'
import {loadArray, popup, takeaway_popup} from '../content.json'
import {commontools} from './mixins/Styling'

export default {
  name: 'app',
  mixins: [commontools],
  data: function () {
    return {
      popup,
      takeaway_popup,
      showPopup: false,
      loadArray,
      isActive: true,
      isReady: false,
      loadCounter: 0
    }
  },
  watch:{
    $route (to, from){
        this.checkTakeawayPopup();
    }
  }, 
  methods: {
    loadImages () {
      this.loadArray.map(url => {
        this.preloadImages('static/img/content/'+url).then(myimg => {
          this.loadCounter--
          if (this.loadCounter === 0) {
            this.isReady = true
            this.checkPopup()
            this.checkTakeawayPopup()
          }
        })
      })
    },
    checkPopup () {
      if (this.popup.active && !this.popup.hasAppeared) {
        this.popup.hasAppeared = true
        if (this.$route.name != this.popup.popup_route) {
          setTimeout(() => {
            this.popup.showMe = true
          }, 2000)
        }   
      }
    },
    checkTakeawayPopup () {
      console.log(this.takeaway_popup.active, this.takeaway_popup.hasAppeared)
      if (this.takeaway_popup.active && !this.takeaway_popup.hasAppeared) {
        if (this.$route.name == this.takeaway_popup.popup_route) {
          this.takeaway_popup.hasAppeared = true
          setTimeout(() => {
            this.takeaway_popup.showMe = true
          }, 2000)
        }   
      }
    }
  },
  mounted: function () {
    if (!('ontouchstart' in document.documentElement)) {
      document.documentElement.className += ' no-touch-device'
    }
    this.popup = popup
    this.takeaway_popup = takeaway_popup
    this.loadCounter = this.loadArray.length
    this.loadImages()
  },
  components: { footbar, navbar, popupoverlay, takeawaypopup }
}

</script>

<style>

/*@import '../static/css/theme.css';*/
@import '../static/css/custom.css';

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
  -webkit-transition-duration: 0.3s;
  -webkit-transition-property: opacity;
  -webkit-transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  opacity: 0;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
}
#app.active {
  opacity: 1!important;
}
/*.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: 2s;
}
.fade-enter-active {
  transition-delay: 2s;
}
.fade-enter, .fade-leave-active {
  opacity: 0
}*/

</style>



// WEBPACK FOOTER //
// App.vue?b2491000